/* eslint-disable @typescript-eslint/no-explicit-any */
import { CdkDragDrop, CdkDragEnd, CdkDragMove, CdkDragStart } from '@angular/cdk/drag-drop';
import { Directive, TemplateRef, inject, input } from '@angular/core';

export interface MovableCardDirectiveImplicitContext {
  onDragStarted: (event: CdkDragStart) => void;
  onDragMoved: (event: CdkDragMove) => void;
  onDragDropped: (event: CdkDragDrop<any>) => void;
  onDragEnded: (event: CdkDragEnd) => void;
  toggleWideMode: () => void;
}

@Directive({
  selector: '[appMovableCard]',
  standalone: true,
})
export class MovableCardDirective<T extends string = any> {
  public readonly appMovableCardKey = input.required<T>();
  public readonly appMovableCardGrow = input<boolean>(false);
  public readonly templateRef = inject(TemplateRef);
  public context: {
    $implicit: MovableCardDirectiveImplicitContext;
  } = {
    $implicit: {
      onDragStarted: () => {},
      onDragMoved: () => {},
      onDragDropped: () => {},
      onDragEnded: () => {},
      toggleWideMode: () => {},
    },
  };

  public setOnDragStarted(onDragStarted: (event: CdkDragStart) => void): void {
    this.patchContext({
      onDragStarted,
    });
  }

  public setOnDragMoved(onDragMoved: (event: CdkDragMove) => void): void {
    this.patchContext({
      onDragMoved,
    });
  }

  public setOnDragDropped(onDragDropped: (event: CdkDragDrop<any>) => void): void {
    this.patchContext({
      onDragDropped,
    });
  }

  public setOnDragEnded(onDragEnded: (event: CdkDragEnd) => void): void {
    this.patchContext({
      onDragEnded,
    });
  }

  public setToggleWideMode(toggleWideMode: () => void): void {
    this.patchContext({
      toggleWideMode,
    });
  }

  public static ngTemplateContextGuard(
    _: MovableCardDirective,
    _context: unknown
  ): _context is {
    $implicit: MovableCardDirectiveImplicitContext;
  } {
    return true;
  }

  private patchContext(implicitContext: Partial<MovableCardDirectiveImplicitContext>): void {
    this.context = {
      $implicit: {
        ...this.context.$implicit,
        ...implicitContext,
      },
    };
  }
}
